import * as React from "react";
import { useQuery, useSubscription } from "urql";
import {
  tokenApprovalsQuery,
  tokenApprovalSubscription,
} from "../../support/mutations";
import { useState } from "react";
import { useEffect } from "react";
import sound from "../../config/sound.mp3";
import useSound from "use-sound";
import Zoom from "@mui/material/Zoom";
import { TransitionGroup } from "react-transition-group";
import { Container, Paper } from "@mui/material";
import { useRef } from "react";
import ApprovalsFilter from "./ApprovalsFilter";
import ApprovalAccordion from "./ApprovalAccordion";

const ApprovalsResult = ({
  variables,
  isLastPage,
  onLoadMore,
  filters,
  setFilters,
}) => {
  const nodeRef = useRef(null);
  //TODO add tokens in background
  const [{ data, fetching, error }] = useQuery({
    query: tokenApprovalsQuery,
    variables: {
      page: variables,
      filter: filters,
    },
  });
  const tokens = data?.tokenApprovals;

  const handleScroll = () => {
    if (
      tokens &&
      tokens.pageInfo.hasNextPage &&
      isLastPage &&
      document.body.scrollHeight / 2 < window.scrollY + window.innerHeight
    ) {
      onLoadMore(tokens.edges[tokens.edges.length - 1].cursor);
    }
  };
  if (isLastPage) window.addEventListener("scroll", () => handleScroll());

  return (
    <>
      {error && <p>Oh no... {error.message}</p>}
      {tokens && (
        <TransitionGroup>
          {tokens.edges.map(({ node }) => (
            <Zoom
              key={node.cursor + node.txHash + node.amount + node.owner}
              nodeRef={nodeRef}
            >
              <Paper sx={{ marginBottom: 1 }}>
                <ApprovalAccordion approval={node} filters={filters} />
              </Paper>
            </Zoom>
          ))}
        </TransitionGroup>
      )}
      {fetching && <p>Loading...</p>}
    </>
  );
};

const Approvals = () => {
  const [play, { stop }] = useSound(sound);
  const [pageVariables, setPageVariables] = useState([
    { first: 25, after: "" },
  ]);
  const [filters, setFilters] = useState({ query: "" });
  useSubscription(
    {
      query: tokenApprovalSubscription,
      variables: { filter: filters },
    },
    () => play()
  );

  useEffect(() => {
    play();
    stop();
  }, [play, stop]);

  useEffect(() => {
    setPageVariables([{ first: 25, after: "" }]);
  }, [filters]);

  return (
    <Container fixed sx={{ marginTop: 2 }}>
      <Paper elevation={5} sx={{ marginBottom: 0 }}>
        <ApprovalsFilter filters={filters} setFilters={setFilters} />
      </Paper>
      {pageVariables.map((variables, i) => (
        <ApprovalsResult
          filters={filters}
          setFilters={setFilters}
          key={"" + variables.after}
          variables={variables}
          isLastPage={i === pageVariables.length - 1}
          onLoadMore={(after) =>
            setPageVariables([...pageVariables, { after, first: 25 }])
          }
        />
      ))}
    </Container>
  );
};

export default Approvals;
